import './driverDetails.css';
import OverallSummary from "../../components/overallSummary/overallSummary";
import {Link} from "react-router-dom";
import DriversSummary from "../../components/driverComponent/driversSummary/driversSummary";
import {useState} from "react";
import {driverSummary} from "../../data/driversData";
import DriverInfo from "../../components/driverInfo/driverInfo";
import VideoSec from "../../components/videoSec/videoSec";
import DriverTrips from "../../components/driverDetailsComponent/driverTrips/driverTrips";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";

const DriverDetails = () => {
    const summary = [
        {
            text: <span><span className={'green-color'}>3092</span>/2847</span>,
            name: 'Kms Travelled',
            color: 'light-color'
        },
        {
            text: <span><span className={'green-color'}>5</span>/4</span>,
            name: 'No of Trips',
            color: 'light-color'
        },
        {
            text: '06',
            name: 'FCW',
            color: 'green-color'
        },
        {
            text: '26',
            name: 'PCW',
            color: 'red-color'
        },
        {
            text: '108',
            name: 'LDW',
            color: 'green-color'
        },
        {
            text: 83,
            name: 'HA',
            color: 'red-color'
        },
        {
            text: 71,
            name: 'HB',
            color: 'red-color'
        },
        {
            text: 41,
            name: 'DIS',
            color: 'green-color'
        },
        {
            text: '213',
            name: 'HMW',
            color: 'red-color'
        },
        {
            text: '08',
            name: 'DRW',
            color: 'green-color'
        },
    ];
    const driverInfo = [
        {
            text: 'Ramesh Jagannath',
            class: ''
        },
        {
            text: 'ID: 6885',
            class: ''
        },
        {
            text: 'Ranking: 25',
            class: ''
        },
        {
            text: 'Accidents: 1',
            class: ''
        },
    ];

    const summaryObj = [
        {
            data: <span><span className={'green-color'}>208</span>/227</span>,
            title: <span>Improved alertness <br/> compared to last week</span>
        },
        {
            data: <span><span className={'green-color'}>187</span>/216</span>,
            title: <span>23% less <br/> Collision warnings</span>
        },
        {
            data: <span><span className={'green-color'}>06</span>/14</span>,
            title: <span>Improved productivity <br/> compared to last week</span>
        },
        {
            data: <span><span className={'green-color'}>105</span>/123</span>,
            title: <span>19% less <br/> Overall violations</span>
        },
        {
            data: <span><span className={'red-color'}>20</span>/14</span>,
            title: <span>Rash driving increased <br/> from last week</span>
        }
    ];



    return (
        <>
            <div className={'content-section page-fade-in'}>
                <div className="round-corner-8 padding-tb-20 flex hr-space-between border-bottom">
                    <Link to=".." relative={'path'} className="flex font-15 gap-10">
                        <div className="back-btn-circular"></div>
                        <div className="highlight-color sf-medium">Back</div>
                    </Link>
                    <div className="flex">
                        <DateRangePicker selectRange={true} classes={'date width-300 item-height-40'}/>
                        <CalendarType/>
                    </div>
                </div>

                {/*....... driver details .......*/}
                <div className="border-bottom margin-b-40"><DriverInfo data={driverInfo}/></div>

                {/*..... overall summary .....*/}
                <div className="margin-b-50"><OverallSummary data={summaryObj}/></div>
            </div>
            <div className="light-back padding-tb-20 margin-b-40">
                <div className={'content-section'}>
                    {/*..... drivers overall summary .....*/}
                    <div className=""><DriversSummary summary={summary}/></div>
                </div>
            </div>

            <div className="content-section">
                {/*....... video section ......*/}
                <div className="margin-b-20">
                    <div className="section-title margin-b-20">Coaching Videos</div>
                    <VideoSec/>
                </div>
                {/*....... video section ......*/}
                <div className="margin-b-40">
                    <div className="section-title margin-b-20">Recent Videos</div>
                    <VideoSec/>
                </div>

                {/*..... driver trips .......*/}
                <div className=""><DriverTrips/></div>
            </div>


        </>
    )
}

export default DriverDetails;
